import React, { FC, useMemo } from 'react';
import { MostReadCardProps } from 'home/types/types';
import striptags from 'striptags';

const MostReadCard: FC<MostReadCardProps> = ({ index, category, title, url, categoryLink }) => {
  const strippedTitle = useMemo(() => striptags(title).replace(/&nbsp;/g, ' '), [title]);

  return (
    <div className="most-read-card">
      <a href={categoryLink} className="tag-text">
        <span className="index-text">{index + 1}</span> {category}
      </a>
      <a href={url} className="heading-wrapper-link">
        <h6 dangerouslySetInnerHTML={{ __html: strippedTitle }}></h6>
      </a>
    </div>
  );
};

export default MostReadCard;
